const icon = require('vue-svgicon');
icon.register({
    'recipe-axis': {
        width: 41,
        height: 41,
        viewBox: '0 0 41 41',
        data: `<path pid="0" d="M20.4 39.8c10.714 0 19.4-8.685 19.4-19.4C39.8 9.687 31.114 1 20.4 1 9.686 1 1 9.686 1 20.4c0 10.715 8.686 19.4 19.4 19.4zM20.4 1.48v5.43M10.72 4.08l2.71 4.7M3.63 11.16l4.7 2.72M1.04 20.85h33.78M39.77 20.85h-5.43M37.17 11.16l-4.7 2.72M30.09 4.08l-2.72 4.7M20.4 16.92v6.55" _stroke="#010101" stroke-width="1.2"/><path pid="1" d="M26.72 28.1c-.22-.85-1.2-1.49-2.37-1.49-1.33 0-2.41.83-2.41 1.85 0 .18.03.36.1.53.29.77 1.22 1.32 2.31 1.32h.09c1.33 0 2.41.83 2.41 1.86 0 .16-.02.32-.08.47-.27.79-1.21 1.38-2.33 1.38s-2.06-.59-2.33-1.38M16.31 34.01a3.7 3.7 0 100-7.4 3.7 3.7 0 000 7.4z" _stroke="#010101" stroke-width="1.2"/>`,
    },
});
